import { InfoOutlined } from '@mui/icons-material';

import { toast, ToastPosition } from '@redwoodjs/web/dist/toast';

const topToastConfig = {
    duration: 5000,
    position: 'top-center' as ToastPosition,
    style: {
        width: '80%',
        fontSize: '24px',
    },
};

export const showErrorToast = (message: string, icon?: React.ReactNode) => {
    const updatedTopToastConfig = icon
        ? {
              ...topToastConfig,
              icon,
          }
        : topToastConfig;
    toast.error(() => {
        return <span data-testid="toast-error">{message}</span>;
    }, updatedTopToastConfig);
};

export const showErrorLong = (message: string) => {
    toast.error(() => {
        return <span data-testid="toast-error">{message}</span>;
    }, { ...topToastConfig, duration: 10000 });
};

export const showSuccessToast = (message: string, icon?: React.ReactNode) => {
    const updatedTopToastConfig = icon
        ? {
              ...topToastConfig,
              icon,
          }
        : topToastConfig;
    toast.success(() => {
        return <span data-testid="toast-success">{message}</span>;
    }, updatedTopToastConfig);
};

export const showInfoToast = (message: string) => {
    showErrorToast(message, <InfoOutlined />);
};
